import { render } from "./put.vue?vue&type=template&id=783a4436&scoped=true"
import script from "./put.vue?vue&type=script&lang=js"
export * from "./put.vue?vue&type=script&lang=js"

import "./put.vue?vue&type=style&index=0&id=783a4436&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783a4436"]])

export default __exports__